<template>
  <div id="app">
    <p class="title">
      Request A Quote
    </p>
    <el-form :model="ruleForm" ref="ruleForm" label-position="top" label-width="100px" class="demo-ruleForm">
      <h2 class="form-title">Please Fill in Your Details</h2>
      <el-form-item label="Name" :required=true style="margin-bottom:0">
          <el-form-item prop="FirstName" class="first-name" :required=true>
            <el-input v-model="ruleForm.FirstName" placeholder="First"></el-input>
          </el-form-item>
          <div class="cen"></div>
          <el-form-item prop="LastName" class="last-name" :required=true>
            <el-input v-model="ruleForm.LastName" placeholder="Last"></el-input>
          </el-form-item>
      </el-form-item>
      <el-form-item label="Email" prop="Email" :rules="[
      { required: true, message: 'Email is required', trigger: 'blur' },
      { type: 'email', message: 'Email is required', trigger: ['blur', 'change'] }
    ]" :required=true>
        <el-input v-model="ruleForm.Email"></el-input>
      </el-form-item>
      <el-form-item label="Phone" prop="Phone">
        <el-input v-model="ruleForm.Phone"></el-input>
      </el-form-item>
      <el-form-item label="Company" prop="Company">
        <el-input v-model="ruleForm.Company"></el-input>
      </el-form-item>
      <el-form-item label="How'd you hear about us?" prop="Way">
        <el-select v-model="ruleForm.Way" placeholder="-select-">
          <el-option label="Social media" value="Social media"></el-option>
          <el-option label="Events and trade shows" value="Events and trade shows"></el-option>
          <el-option label="Zigitech representative" value="Zigitech representative"></el-option>
          <el-option label="Zigitech newsletter" value="Zigitech newsletter"></el-option>
          <el-option label="Search engine" value="Search engine"></el-option>
          <el-option label="Word of mouth" value="Word of mouth"></el-option>
          <el-option label="Personalized mailing" value="Personalized mailing"></el-option>
          <el-option label="Magazine or industry publication" value="Magazine or industry publication"></el-option>
          <el-option label="Industry related websites" value="Industry related websites"></el-option>
          <el-option label="Returning customer" value="Returning customer"></el-option>
          <el-option label="Other" value="Other"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Project Description (Please include material, quantity & finishing)" prop="Desc">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="ruleForm.Desc"></el-input>
      </el-form-item>
      <el-form-item label="Choose File Upload">
        <el-upload
         :on-success="succUpload"
          class="upload-demo"
          drag
          :limit=1
          name="file"
          action="https://api.zigi-tech.com/API/Upload/Img"
          :multiple=false>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drag & Drop or <em>Choose File</em></div>
          <div class="el-upload__tip" slot="tip">File size should be less than 80MB.</div>
        </el-upload>
        <p style="font-size:12px; color:#888">Please attach your 3D drawing (preferably STEP and IGS format ). Got multiple files? Put all your files in a folder  and compress the folder into ZIP or RAR file. (File Type: doc|excel|png|jpeg|csv|pdf)
Alternatively, send through your RFQ by email. enquiry@zigi-tech.com</p>
      </el-form-item>
      <el-form-item class="sub-btn">
        <el-button type="primary" :loading=loading :disabled=disableBtn @click="submitForm('ruleForm')">Submit</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        disableBtn: false,
        loading: false,
        ruleForm: {
          LastName: '',
          FirstName: '',
          Email: '',
          Phone: '',
          Company: '',
          Way: '',
          Desc: '',
          FileName: '',
          Path: ''
        },
      };
    },
    methods: {
      submitForm(formName) {
        const vm = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            vm.axios.post('https://api.zigi-tech.com/API/Message/sendQuote', vm.ruleForm).then(() => {
                // console.log(res);
                this.$message({
                  type:'success',
                  message:'success'
                });
                this.disableBtn = true;
                this.loading = false;
            });
          } else {
            this.$message({
              type:'error',
              message:'Something required'
            });
            this.disableBtn = false;
            return false;
          }
        }).catch(() => {
          this.$message({
              type:'error',
              message:'Send fail'
            });
        });
      },
      succUpload(obj) {
        const data = obj.data;
        this.disableUpload = true;
        this.ruleForm.FileName = data.name;
        this.ruleForm.Path = data.url;
      }
    }
  }
</script>

<style>
.sub-btn{
  text-align: center;
  margin-top: 50px;
}
.sub-btn .el-button{
  padding: 14px 30px;
  font-size: 16px;
}
.form-title{
  margin: 0;
  margin-bottom: 30px;
    border-bottom: 1px solid #D7D7D7;
    font-size: 22px;
    color: #000;
    font-weight: 500;
    font-family: 'Open Sans',"Lucida Grande",Arial,Arimo,Helvetica,sans-serif;
    padding-bottom: 10px;
    position: relative;
}
.demo-ruleForm{
  padding: 20px;
}
.title{
  background: #494949;
    border-bottom: 1px solid #EAEAEA;
    margin: 0;
    padding: 20px 25px;
    -webkit-border-radius: 2px 2px 0 0;
    -moz-border-radius: 2px 2px 0 0;
    border-radius: 2px 2px 0 0;
    color: #fff;
    box-sizing: content-box;
}
.upload-demo .el-upload, .el-upload-dragger{
  width: 100%;
}
.el-form-item__label{
  font-weight: 800;
  color: #333;
}
.first-name{
  float: left;
  width: 48%;
  position: relative;
}
/* .first-name::before{
position: absolute;
bottom: -23px;
left: 2px;
font-size: 12px;
color: #888;
content: 'First';
} */
.last-name{
  float: left;
  width: 48%;
  position: relative;
}
/* .last-name::before{
position: absolute;
bottom: -23px;
left: 2px;
font-size: 12px;
color: #888;
content: 'Last';
} */
.cen{
  float: left;
  width: 4%;
  height: 20px;
}
</style>
